import moment from 'moment';
import { useSelector } from 'react-redux';

import {
    platform,
    CppEvents,
    CppUserRoles,
} from '../Analytics/constants';
import { deriveUserSubscriptionType } from '../Analytics/subscriptionType';
import { trackEvent } from '../Analytics/TrackedClick';

const findCollegeCoachMembership = (user) => user?.clubMemberships?.find((m) => {
    const tier = m?.tierTypeName?.toLowerCase();
    return tier === 'free college' || tier === 'pro college';
}) ?? null;

const useCPPTracking = () => {
    const user = useSelector(({ auth }) => auth?.user);
    const graduationDate = useSelector(
        (state) => state.profile?.data?.studentInfo?.graduationDate,
    );

    const userSubscriptionStatus = deriveUserSubscriptionType(user);
    const collegeCoachMembership = findCollegeCoachMembership(user);
    const userRole = collegeCoachMembership ? CppUserRoles.CPP_COACH : CppUserRoles.CPP_PLAYER;
    const cppCoachSchoolId = collegeCoachMembership?.clubId ?? null;
    const gradMoment = graduationDate ? moment(graduationDate) : null;
    const gradYear = gradMoment?.isValid() ? gradMoment.year() : null;

    const basePayload = {
        platform,
        userSubscriptionStatus,
        userRole,
    };

    const trackPlayerEngagement = (playerAction, extraProps = {}) => {
        trackEvent(CppEvents.CPP_PLAYER_ENGAGEMENT, {
            ...basePayload,
            ...(gradYear != null && { gradYear }),
            player_action: playerAction,
            ...extraProps,
        });
    };

    const trackCoachEngagement = (coachAction, surface, extraProps = {}) => {
        trackEvent(CppEvents.CPP_COACH_ENGAGEMENT, {
            ...basePayload,
            ...(cppCoachSchoolId && { cpp_coach_school_id: cppCoachSchoolId }),
            coach_action: coachAction,
            surface,
            ...extraProps,
        });
    };

    return { trackPlayerEngagement, trackCoachEngagement };
};

export default useCPPTracking;
